module.exports = __webpack_public_path__ + "img/seo-email-icon.svg";